<template>
    <div v-show="showCurtain" :class="['curtain-overlay', { 'is-hidden': !isRevealing && !showCurtain }]">
        <LottieObject v-if="!isRevealing" jsonFile="site-loading_2-light.json" :loop="true" :autoPlay="true" :speed="1" />
        <LottieObject v-if="isRevealing" jsonFile="site-reveal_3-light.json" :loop="false" :autoPlay="true" :speed="1" @on-complete="onAnimationComplete" />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import LottieObject from "@/components/general/LottieObject.vue"

const emit = defineEmits(['curtain-closed']);
const MINIMUM_LOADING_DURATION = 3000;
const FADE_OUT_DURATION = 500;

const showCurtain = ref(true);
const isPageLoaded = ref(false);
const isRevealing = ref(false);
const minTimeElapsed = ref(false);

function tryStartReveal() {
    if (isPageLoaded.value && minTimeElapsed.value) {
        startRevealAnimation();
    }
}

function startRevealAnimation() {
    isRevealing.value = true;
}

function onAnimationComplete() {
    isRevealing.value = false;

    setTimeout(() => {
        showCurtain.value = false;
        emit('curtain-closed');
    }, FADE_OUT_DURATION);
}

onMounted(() => {
    setTimeout(() => {
        minTimeElapsed.value = true;
        tryStartReveal();
    }, MINIMUM_LOADING_DURATION);

    if (document.readyState === 'complete') {
        isPageLoaded.value = true;
        tryStartReveal();
    } else {
        window.addEventListener('load', () => {
            isPageLoaded.value = true;
            tryStartReveal();
        }, { once: true });
    }
});
</script>

<style>
.curtain-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    transition: opacity 0.5s ease-out;
    pointer-events: none;
}

.curtain-overlay.is-hidden {
    opacity: 0;
    pointer-events: none;
}

:root {
    --lottie-ratio: 1.77777;
}

.curtain-overlay>* {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.lottie-wrapper {
    width: 100vw;
    height: 100vh;
    min-width: max(100vw, calc(100vh * var(--lottie-ratio)));
    min-height: max(100vh, calc(100vw / var(--lottie-ratio)));
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
}

.lottie-wrapper svg,
.lottie-wrapper canvas {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
    object-position: center;
    transform-origin: center center;
}
</style>